module.exports = __webpack_public_path__ + "img/wxtpl-template-tips.361a9c73.svg";